import moment from 'moment';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector } from 'react-redux';
import {
  Box,
  Button,
  Card,
  CardHeader,
  Chip,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  IconButton,
} from '@mui/material';
import {
  RemoveRedEyeRounded, ArrowRight,
} from '@mui/icons-material';
import { currencyFormatter } from '../../utils';
import LoadingProgress from '../LoadingProgress';

function OrderList({
  loading, orders, title, paginate, ...rest
}) {
  const navigate = useNavigate();

  const orderState = useSelector((state) => state.orderReducer);
  const { loadingOrders } = orderState;

  const navigateToOrders = (event) => navigate('/app/orders');

  const getLabelColor = (status) => {
    let color;
    if (status === 'confirmed') {
      color = 'primary';
    } else if (status === 'delivered') {
      color = 'success';
    } else if (status === 'canceled') {
      color = 'error';
    } else {
      color = 'default';
    }
    return color;
  };

  const paymentColor = (status) => {
    let color;
    if (status === 'Credit') {
      // color = purple.A700;
      color = 'secondary';
    } else if (status === 'Lipa Na Mpesa') {
      // color = green.A700;
      color = 'success';
    } else {
      // color = cyan.A700;
      color = 'warning';
    }
    return color;
  };

  const gotToPrint = (order) => {
    if (order.paymentMethod === 'Credit') {
      navigate(`/app/orders/print/${order.orderNumber}`);
    } else if (order.paymentMethod === 'Lipa Na Mpesa') {
      navigate(`/app/orders/${order.orderNumber}`);
    }
  };

  return (
    <Card>
      <CardHeader title={title} />
      <Divider />

      { loadingOrders ? <LoadingProgress />

        : (
          <PerfectScrollbar>
            <Box sx={{ minWidth: 800 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      Order number
                    </TableCell>
                    <TableCell>
                      Amount
                    </TableCell>
                    <TableCell sortDirection="desc">
                      <Tooltip
                        enterDelay={300}
                        title="Sort"
                      >
                        <TableSortLabel
                          active
                          direction="desc"
                        >
                          Date
                        </TableSortLabel>
                      </Tooltip>
                    </TableCell>
                    {
                  paginate
                  && (
                  <>
                    <TableCell>
                      Status
                    </TableCell>
                    <TableCell>
                      Payment
                    </TableCell>
                  </>
                  )
                }

                    <TableCell>
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {orders.map((order) => (
                    <TableRow
                      hover
                      key={order.orderNumber}
                    >
                      <TableCell>
                        {order.orderNumber}
                      </TableCell>
                      <TableCell>
                        {currencyFormatter(order.amount)}
                      </TableCell>
                      <TableCell>
                        {moment(order.createdAt).format('DD/MM/YYYY')}
                      </TableCell>
                      {
                    paginate && (
                    <>
                      <TableCell>
                        <Chip
                          color={getLabelColor(order.orderStatus)}
                          label={order.orderStatus ? order.orderStatus.toUpperCase() : ''}
                          size="medium"
                        />
                      </TableCell>

                      <TableCell>
                        <Chip
                          color={paymentColor(order.paymentMethod)}
                          label={order.paymentMethod}
                          variant="outlined"
                        />

                      </TableCell>
                    </>
                    )
                  }

                      <TableCell>
                        {
                      (order.paymentMethod === 'Credit' || order.paymentMethod === 'Lipa Na Mpesa')
                      && <IconButton onClick={() => gotToPrint(order)}><RemoveRedEyeRounded sx={{ height: 30, width: 30 }} /></IconButton>
                    }

                        {/* <IconButton onClick={() => goToDetails(order)}><CloudDownload /></IconButton> */}
                      </TableCell>
                    </TableRow>
                  ))}
                  {!orders && (
                  <TableRow style={{ height: 53 }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                  )}
                </TableBody>
              </Table>
            </Box>
          </PerfectScrollbar>
        )}
      {
        !paginate && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            p: 2,
          }}
        >
          <Button
            color="primary"
            endIcon={<ArrowRight />}
            size="small"
            variant="text"
            onClick={navigateToOrders}
          >
            View all
          </Button>
        </Box>
        )
      }

    </Card>
  );
}

OrderList.propTypes = {
  orders: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  paginate: PropTypes.bool,
};

export default OrderList;
